var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-alert", { attrs: { outline: "", type: "warning", value: true } }, [
        _c("div", [_c("strong", [_vm._v("Formulaire déprécié")])]),
        _vm._v("\n\t\tVeuillez utiliser la nouvelle version du launcher.\n\t")
      ]),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "launch_form" },
        _vm._l(_vm.wf_data.parameters, function(param) {
          return _c("div", { key: param.name }, [
            param.name === "legacy_contract_id"
              ? _c(
                  "div",
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.options.contracts,
                        hint: _vm.get_hint(param),
                        "persistent-hint": "",
                        clearable: "",
                        dense: "",
                        "item-value": "id",
                        filter: _vm.customContractsFilter,
                        "open-on-clear": "",
                        rules: _vm.get_validation_rules(
                          param.type,
                          param.required
                        )
                      },
                      on: {
                        change: function($event) {
                          _vm.get_contract_assets()
                          _vm.form_change()
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm._f("maestroParamLabel")(param)) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "selection",
                            fn: function(data) {
                              return [
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(data.item.id) +
                                          " - " +
                                          _vm._s(data.item.name) +
                                          " - " +
                                          _vm._s(data.item.title) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function(data) {
                              return [
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(data.item.id) +
                                            " - " +
                                            _vm._s(data.item.name) +
                                            " - " +
                                            _vm._s(data.item.title) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      data.item.content_owner
                                        ? _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  data.item.content_owner.name
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.form.parameters[param.name],
                        callback: function($$v) {
                          _vm.$set(_vm.form.parameters, param.name, $$v)
                        },
                        expression: "form.parameters[param.name]"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            param.name === "asset_ids"
              ? _c(
                  "div",
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.options.asset_list,
                        hint: _vm.get_hint(param),
                        "persistent-hint": "",
                        multiple: "",
                        clearable: "",
                        dense: "",
                        "item-text": "mat_id",
                        "item-value": "mat_id",
                        "no-data-text": "Aucun asset trouvé",
                        rules: [_vm.validations["array-filled"]]
                      },
                      on: {
                        change: function($event) {
                          return _vm.form_change()
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm._f("maestroParamLabel")(param)) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.selected_assets,
                        callback: function($$v) {
                          _vm.selected_assets = $$v
                        },
                        expression: "selected_assets"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "pa-2 mb-3" },
            [
              _c("tree-view", {
                attrs: {
                  data: _vm.form,
                  options: { maxDepth: 3, rootObjectKey: "Output" }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "pa-2" },
            [
              _c("tree-view", {
                attrs: {
                  data: _vm.wf_data,
                  options: { maxDepth: 0, rootObjectKey: "Job Descriptor" }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67eafe46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67eafe46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/jobs/launcher/job_launcher_form_legacy_archive_contract.vue
// module id = null
// module chunks = 